import { render, staticRenderFns } from "./StocksList.vue?vue&type=template&id=171c2397&"
import script from "./StocksList.vue?vue&type=script&lang=js&"
export * from "./StocksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports